module.exports = __webpack_public_path__ + "img/08.fd0141df.jpg";